import React, { useState, useRef } from 'react';
import { DEFAULT_TTL, setLoginToken } from './Utils';
import './ModernLogin.css';

function ModernLogin() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const passwordRef = useRef();

    const doLogin = () => {
        var protocl = window.location.protocol;
        if (username === "" || password === "") {
            window.layer.msg("请输入用户名和密码");
            return;
        }
        window.$.ajax({
            type: 'POST',
            url: protocl + '//saas.yonyouaud.com/api/client-info/generateAccessToken',
            contentType: 'application/json;charset=utf8',
            data: JSON.stringify({ "clientId": username, "username": username, "clientSecret": password, "ttl": DEFAULT_TTL }),
            success: function (data) {
                var code = data.errorCode;
                if (code && code === "success") {
                    window.layer.msg("登录成功");
                    data.username = username;
                    setLoginToken(data);
                    setTimeout(function () {
                        window.location.reload();
                    }, 1000);
                } else {
                    window.layer.msg(data.errorMessage);
                }
            }
        })
    }

    return (
        <div className="modern-container">
            <div className="floating-circle-1"></div>
            <div className="floating-circle-2"></div>
            <div className="floating-circle-3"></div>
            <header>
                <div className="modern-logo">审友A8 - 审友云</div>
            </header>
            <div className="modern-login-box">
                <h2>欢迎登录审友云</h2>
                <form onSubmit={(e) => e.preventDefault()}>
                    <input 
                        type="text" 
                        placeholder="用户名或邮箱" 
                        value={username} 
                        onChange={(e) => setUsername(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                if (passwordRef.current) {
                                    passwordRef.current.focus();
                                }
                            }
                        }}
                        required 
                    />
                    <input 
                        type="password" 
                        placeholder="密码" 
                        ref={passwordRef}
                        value={password} 
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                doLogin();
                            }
                        }}
                        required 
                    />
                    <button type="button" onClick={doLogin}>登录</button>
                </form>
                {/* <p>忘记密码？<a href="#">点击这里</a></p> */}
            </div>
            <div className="modern-footer">
                <span>Copyright © {new Date().getFullYear()} <a rel="noreferrer" href="https://www.yonyouaud.com" target="_blank">北京审友数治科技有限公司</a> 版权所有.</span>
            </div>
        </div>
    );
}

export default ModernLogin;